import { Container, CircularProgress } from "@mui/material";
import ItemList from "../../components/ItemList";
import { getBackend } from "../../api/backend";
import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { fetchWithCache } from "../../utils/cacheUtils";

const Clients = () => {
  const [cities, setCities] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const fetchCities = async () => {
    setIsLoading(true);
    
    try {
      // Use the fetchWithCache utility
      const fetchCitiesData = async () => {
        const geoResponse = await getBackend("municipios");
        return geoResponse.municipios
          .map((city) => `${city.nombre}, ${city.provincia.nombre}`)
          .sort((a, b) => a.localeCompare(b));
      };
      
      const alphabeticalOrderedCities = await fetchWithCache('cities', fetchCitiesData);
      
      setCities(
        Object.fromEntries(alphabeticalOrderedCities.map((city) => [city, city]))
      );
    } catch (error) {
      console.error("Error fetching cities data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fieldsConfig = [
    { key: "uuid", label: "Placeholder", type: "text", displayForm: false, displayList: false },
    { key: "name", label: "Nombre", type: "text", required: true, displayForm: true, displayList: true },
    { key: "email", label: "E-mail", type: "text", displayForm: true, displayList: true },
    { key: "phone", label: "Telefono", type: "text", displayForm: true, displayList: true },
    { key: "address", label: "Dirección", type: "text", required: true, displayForm: true, displayList: true },
    { key: "city", label: "Ciudad", type: "select", options: cities, required: true, displayForm: true, displayList: true }, 
    { key: "cuit", label: "CUIT/CUIL", type: "text", displayForm: true, displayList: true },
  ];

  useEffect(() => {
    fetchCities();
  }, []);

  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Clientes
        </Typography>
      </Box>
      {!isLoading ? (
        <ItemList fields={fieldsConfig} tableName="clients" hasCheckbox={true} objectName={"client"} tabledescription={"Clientes"}/>
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};

export default Clients;
